import axios from "../http";
let module = "/source-code";
function askForCode(data){
  return axios.post(module,data);
}

export default{
  askForCode
}



// WEBPACK FOOTER //
// ./src/api/modules/askForCode.js